import { get, post } from './http-calls';

export const UserHolidays_ByDate = async (date) => {
    let res = await get(`TCardUserHolidayRecords/TCardUserHoliday_ByDate?Date=${date}`, { useAuthToken: true });
    return res;
};

export const DeleteHolidayRecodrs = async (data) => {
    let res = await post(`TCardUserHolidayRecords/TCardUserHoliday_Delete`, data, { useAuthToken: true });
    return res;
};
export const getUserForHoliday = async (branchID) => {
    let res = await get(`TCardUserHolidayRecords/TCardCalendar_GetUsers?BranchID=${branchID}`, { useAuthToken: true });
    return res;
};
export const UserHolidays_AddUpdate = async (data) => {
    let res = await post(`TCardUserHolidayRecords/TCardUserHoliday_AddUpdate`, data, { useAuthToken: true });
    return res;
};

export const getTCardUserHolidayDropdown = async () => {
    let res = await get(`TCardUserHolidayRecords/TCardUserHoliday_ScreenDropdown`, { useAuthToken: true });
    return res;
};